import {
  yappyPayment,
  broker,
  creditCard,
  cashPayment,
  achPayment,
  clavePayment,
} from 'data-layer-cr/dist/constants/paymentTypes';

export const brokerPaymentString = 'Pago al corredor';
export const cashPaymentString = 'Directo en caja';
export const cardPaymentString = 'Tarjeta';
export const achPaymentString = 'Pago por ACH';
export const clavePaymentString = 'Tarjeta Clave';
export const yappyPaymentString = 'Yappy';

export default function getPaymentMethodDescription(
  type: string,
  cardType: string,
): string {
  switch (type) {
    case broker:
      return brokerPaymentString;
    case cashPayment:
      return cashPaymentString;
    case creditCard:
      return `${cardPaymentString} ${cardType}`;
    case achPayment:
      return achPaymentString;
    case clavePayment:
      return clavePaymentString;
    case yappyPayment:
      return yappyPaymentString;
    default:
      return '';
  }
}
